import React, {useEffect} from 'react';
import {useLogout} from '../../services';

export const LogoutScene: React.FC = () => {
  const logout = useLogout();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => logout(), []);
  return null;
};
